import axiosInstance from '../config/axios';
import { API_BASE_URL } from '../config/constants';

export interface PriceGroup {
  priceGroupCode: string;
  priceGroupDescription: string;
  defaultCurrencyCode: string;
  isBlocked: boolean;
}

export interface CustomerDiscountGroup {
  discountGroupCode: string;
  discountGroupDescription: string;
}

export const customerLookupApi = {
  getPriceGroups: async (): Promise<PriceGroup[]> => {
    const res = await axiosInstance.get<PriceGroup[]>(`${API_BASE_URL}/api/v1/CustomerLookup/price-groups`);
    return res.data || [];
  },
  getCustomerDiscountGroups: async (): Promise<CustomerDiscountGroup[]> => {
    const res = await axiosInstance.get<CustomerDiscountGroup[]>(`${API_BASE_URL}/api/v1/CustomerLookup/customer-discount-groups`);
    return res.data || [];
  }
};
